import { MemberService } from '../services/member.service';
import { HotelService } from '../services/hotel.service';
import { ReservationService } from '../services/reservation.service';
import { LogService } from '../services/logging.service';
import { Actions } from '../../store/actions';
import { AppAction, AppActionState, IAppState } from '../../store/interfaces/IAppState';
import { NgRedux } from '@angular-redux/store';
import { CommonActionsDelegate } from './common-actions.delegate';
import { Injectable } from '@angular/core';
import { IAppConfig } from '../../store';
import { AccountStayPreferences } from '../model/user/stay-preferences/stay-preference.model';
import { AccountStayPreferencesService } from '../services/account-stay-preference.service';
const CLASS_NAME = 'ModifyAccountDelegate';
@Injectable()
export class ModifyAccountDelegate extends CommonActionsDelegate {
  private _appConfig;
  constructor(_ngRedux: NgRedux<IAppState>,
    _actions: Actions,
    _logService: LogService,
    _reservationService: ReservationService,
    private _stayPreferencesService: AccountStayPreferencesService,
    _hotelService: HotelService,
    _memberService: MemberService) {
    super(_ngRedux, _actions, _logService, _reservationService, _hotelService, _memberService);
    this._appConfig = _ngRedux.getState().appConfig as IAppConfig;
  }

  fetchAccountStayPreferences() {
    this._actions.dispatchAccountStayPreferencesAction(AppAction.GET_ACCOUNT_STAY_PREFERENCES, AppActionState.INITIAL);
    this._stayPreferencesService.getAccountStayPreferences()
      .subscribe(stayPreferences => {
        this._actions.dispatchAccountStayPreferencesAction(AppAction.GET_ACCOUNT_STAY_PREFERENCES, AppActionState.SUCCESS, stayPreferences);
      },
        error => {
          this._logService.error(`Error retrieving Account stay preferences:`, CLASS_NAME, error);
          this._actions.dispatchAccountStayPreferencesAction(AppAction.GET_ACCOUNT_STAY_PREFERENCES, AppActionState.ERROR, null, error);
        }
      );
  }

  updateAccountStayPreferences(saveToAPI: boolean, updatedValues: object) {
    if (!saveToAPI && !!this._ngRedux.getState().accountStayPreferences) {
      const formattedAccountStayPreferences: AccountStayPreferences = new AccountStayPreferences(this._ngRedux.getState().accountStayPreferences, updatedValues);
      this._actions.dispatchAccountStayPreferencesAction(AppAction.MODIFY_ACCOUNT_STAY_PREFERENCES, AppActionState.INITIAL, formattedAccountStayPreferences);
    }

    if (saveToAPI) {
      this._actions.dispatchAccountStayPreferencesAction(AppAction.MODIFY_ACCOUNT_STAY_PREFERENCES, AppActionState.INITIAL, this._ngRedux.getState().accountStayPreferences);
      const stayPreferences: AccountStayPreferences = this._ngRedux.getState().accountStayPreferences;
      if (!!stayPreferences) {
        this._stayPreferencesService.setAccountStayPreferences(stayPreferences)
          .subscribe(stayPreferences => {
            this._actions.dispatchAccountStayPreferencesAction(AppAction.MODIFY_ACCOUNT_STAY_PREFERENCES, AppActionState.SUCCESS, stayPreferences);
          },
            error => {
              this._logService.error(`Error retrieving Account stay preferences: `, CLASS_NAME, error);
              this._actions.dispatchAccountStayPreferencesAction(AppAction.MODIFY_ACCOUNT_STAY_PREFERENCES, AppActionState.ERROR, null, error);
            }
          );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/delegates/modify-account.delegate.ts